<template>
  <a :href="login" class="link" v-if="isShow()">
    <v-btn :loading="loading" color="primary" block rounded class="text-none">
      <b>{{$t('login')}}</b>
    </v-btn>
  </a>
</template>
<script>
  import authSession from "../../../service/auth-session";

  export default {
    name: 'BtnLogin',
    props: ['screenData'],
    components: {
    },
    data: () => ({
      loading: false,
    }),
    computed: {
      login: function() {
        return `${process.env.VUE_APP_API_V1_URL}/oauth2/authorization/google`
      },
    },
    methods: {
      isShow: function() {
        return !authSession.state.authenticated
      }
    },
  }
</script>
<style scoped>
</style>